import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { CreateGroupChatModal } from "./CreateGroupChatModal";
import { useTranslation } from "react-i18next";

export const CreateGroupChatButton = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      <Button
        type="button"
        variant="new_default"
        onClick={handleOpenModal}
        className="h-8 rounded-lg px-3 text-xs font-medium"
      >
        <Plus />
        {t("chats.newGroup")}
      </Button>
      <CreateGroupChatModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};
